<template>
    <div class="wework-app-box">
        <div v-if="hasGetData" class="wework-app-tit">
            请使用已绑定的企业微信
            <b>{{ accountInfo.corp_name }}</b>
            来安装以下应用
        </div>
        <app-install-list></app-install-list>
    </div>
</template>

<script>
import getCorpInfo from '@/pages/mng/third_account/weworkCombine/api/getCorpInfo';
import AppInstallList from '../../app-install-list';

export default {
    components: {
        AppInstallList
    },

    data() {
        return {
            hasGetData: false,
            accountInfo: {}
        };
    },

    created() {
        getCorpInfo()
            .then(res => {
                const { corpInfo } = res || {};

                this.accountInfo = corpInfo || {};

                this.hasGetData = true;
            })
            .catch(message => {
                this.$message.error(message || '获取企业微信账号信息失败');
            });
    }
};
</script>
<style scoped lang="less">
@import './tab-app.less';
</style>
